import { useMemo } from 'react';
import productsData from "../data/products.json";

const roleLabels = {
	"designLead": "Design Lead",
	"contributor": "Contributors"
};

const roleOrder = ["designLead", "contributor"];

export const useContributorsByRole = (productId) => {
	return useMemo(() => {
		const product = productsData.find(p => p.id === productId);
		
		if (!product || !product.contributors) {
			return null;
		}
		
		const contributorsByRole = {};
		product.contributors.forEach(({ id, role }) => {
			if (!contributorsByRole[role]) {
				contributorsByRole[role] = [];
			}
			contributorsByRole[role].push(id);
		});
		
		return {
			contributorsByRole,
			roleLabels,
			roleOrder
		};
	}, [productId]);
};
